/**
 * Generates a regular expression pattern from a given input string that may contain a wildcard (*).
 * The resulting pattern can be used for flexible string matching.
 *
 * @param inputString - A string that may contain a wildcard (*) indicating a flexible pattern.
 * @returns A regular expression object representing the pattern derived from the input string.
 *
 * @example
 * const pattern = generateWildcardRegexPattern('https://bible-review-*.bible.com/authenticate');
 * console.log(pattern.test('https://bible-review-df234sbible.com/authenticate')); // true
 * console.log(pattern.test('https://example.com/authenticate')); // false
 */
export function generateWildcardRegexPattern(inputString: string) {
  // Escape special characters
  const escapedString = inputString.replace(/[.+?^${}()|[\]\\]/g, '\\$&');
  return new RegExp(`^${escapedString.replace(/\*/g, '.*')}$`);
}
